import React, { useEffect, useState } from "react";
import MyEditor from "../../../components/common/editor/CKEditorComponent";
import { Tabs, Card, Button, Space, message } from "antd";
import "./cms.scss";
import { useDispatch, useSelector } from "react-redux";
import { getCMSData, updateCMSData } from "../../../redux/reducer/cmsManagementSlice";
import ContentScalaton from "../../../components/scalaton/ContentScalaton";

const { TabPane } = Tabs;

const CmsMgmnt = () => {
  const dispatch = useDispatch();
  const { cmsData, cmsLoading } = useSelector((state) => state?.cmsManagement);

  // Store multilingual content
  const [editorData, setEditorData] = useState({
    content_en: "",
    content_es: "",
    content_pt: "",
  });

  const [activeTab, setActiveTab] = useState("1"); // Default tab
  const [previewMode, setPreviewMode] = useState(true); // Show preview first

  // Fetch CMS content when the component mounts or tab changes
  useEffect(() => {
    dispatch(getCMSData(activeTab));
  }, [dispatch, activeTab]);

  // Update editor data when cmsData is updated from API
  useEffect(() => {
    if (cmsData) {
      setEditorData({
        content_en: cmsData?.content_en || "",
        content_es: cmsData?.content_es || "",
        content_pt: cmsData?.content_pt || "",
      });
    }
  }, [cmsData]);

  // Handle tab switch
  const handleTabChange = (key) => {
    setActiveTab(key);
    setPreviewMode(true); // Show preview when switching tabs
  };

  // Handle editor content change
  const handleChange = (lang, event, editor) => {
    setEditorData((prev) => ({
      ...prev,
      [lang]: editor?.getData(),
    }));
  };

  // Enable Edit Mode
  const handleEdit = () => {
    setPreviewMode(false);
  };



  // Save and Update CMS Data
  const handleSave = async () => {
    const updatedContent = {
      content_en: editorData.content_en,
      content_es: editorData.content_es,
      content_pt: editorData.content_pt,
    };
    try {
      await dispatch(updateCMSData({ contentType: activeTab, updatedContent })).unwrap();
      message.success("CMS content updated successfully!");
      dispatch(getCMSData(activeTab)); // Refresh data
      setPreviewMode(true); // Switch back to preview mode
    } catch (error) {
      message.error("Failed to update CMS content.");
    }
  };

  return (
    <>
      <div className="addBtnBx dflex">
        <div className="tableHeading">CMS Management</div>
        <Space>
          {!previewMode ? (
            <>
              <Button onClick={() => setPreviewMode(true)}>Cancel</Button>
              <Button type="primary" onClick={handleSave}>Save & View Details</Button>
            </>
          ) : (
            <Button type="primary" onClick={handleEdit}>Edit Details</Button>
          )}
        </Space>
      </div>

      <Card>
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          type="card"
          tabBarStyle={{ color: "#45AE51", fontWeight: "bold" }}
          className="custom-tabs"
        >
          {/* About Us Tab */}
          <TabPane tab="About Us" key="1">
            <div className="tableHeading">About Us</div>
            {previewMode ? (
              <>
              {cmsLoading ? <ContentScalaton /> : 
                <div className="content-display" dangerouslySetInnerHTML={{ __html: editorData.content_en }} />
              }
              </>
            ) : (
              <>
              <h5 className="editor-heading">English Content (en)</h5>
                <MyEditor editorContent={editorData.content_en} onChange={(event, editor) => handleChange("content_en", event, editor)} />
                <h5 className="editor-heading">Spanish Content (es)</h5> 
                <MyEditor editorContent={editorData.content_es} onChange={(event, editor) => handleChange("content_es", event, editor)} />
                <h5 className="editor-heading">Portuguese Content (pt)</h5>
                <MyEditor editorContent={editorData.content_pt} onChange={(event, editor) => handleChange("content_pt", event, editor)} />
              </>
            )}
          </TabPane>

          {/* Terms & Conditions Tab */}
          {/* <TabPane tab="Terms & Conditions" key="2">
            <div className="tableHeading">Terms & Conditions</div>
            {previewMode ? (
              <>
               {cmsLoading ? <ContentScalaton /> : 
                <div className="content-display" dangerouslySetInnerHTML={{ __html: editorData.content_en }} />
               }
              </>
            ) : (
              <>
               <h5 className="editor-heading">English Content (en)</h5>
                <MyEditor editorContent={editorData.content_en} onChange={(event, editor) => handleChange("content_en", event, editor)} />
                <h5 className="editor-heading">Spanish Content (es)</h5> 
                <MyEditor editorContent={editorData.content_es} onChange={(event, editor) => handleChange("content_es", event, editor)} />
                <h5 className="editor-heading">Portuguese Content (pt)</h5>
                <MyEditor editorContent={editorData.content_pt} onChange={(event, editor) => handleChange("content_pt", event, editor)} />
              </>
            )}
          </TabPane> */}

          {/* Privacy Policies Tab */}
          {/* <TabPane tab="Privacy Policies" key="3">
            <div className="tableHeading">Privacy Policies</div>
            {previewMode ? (
              <>
               {cmsLoading ? <ContentScalaton /> : 
                <div className="content-display" dangerouslySetInnerHTML={{ __html: editorData.content_en }} />
               }
              </>
            ) : (
              <>
                <h5 className="editor-heading">English Content (en)</h5>
                <MyEditor editorContent={editorData.content_en} onChange={(event, editor) => handleChange("content_en", event, editor)} />
                <h5 className="editor-heading">Spanish Content (es)</h5> 
                <MyEditor editorContent={editorData.content_es} onChange={(event, editor) => handleChange("content_es", event, editor)} />
                <h5 className="editor-heading">Portuguese Content (pt)</h5>  
                <MyEditor editorContent={editorData.content_pt} onChange={(event, editor) => handleChange("content_pt", event, editor)} />
              </>
            )}
          </TabPane> */}
        </Tabs>
      </Card>
    </>
  );
};

export default CmsMgmnt;


